/* src/app/messages/messages.component.css */
.message-icon {
  position: absolute;
  left: 0px;
  margin: 0px;
  min-width: 50px;
  max-width: 50px;
  height: 100%;
  background-color: rgba(200, 0, 0, 0.884);
  color: white;
}
#messageFloat {
  min-width: 400px;
  width: 40%;
  border-radius: 4px;
  padding: 5px;
  position: fixed;
  z-index: 10000;
  right: 5px;
  top: 50px;
  border: 1px;
  border-color: #303030;
  border-style: solid;
  background-color: #efefef;
}
.alert {
  margin: 2px;
}
#messageToggle {
  color: white;
}
#messageToggle:hover {
  color: lightblue;
}
/*# sourceMappingURL=messages.component.css.map */
